import React from 'react';
import { industries } from '../data/mock';
import {
  ShoppingCart, Cloud, Briefcase, HeartPulse,
  DollarSign, Home, GraduationCap, Truck
} from 'lucide-react';

const iconMap = {
  'shopping-cart': ShoppingCart,
  'cloud': Cloud,
  'briefcase': Briefcase,
  'heart-pulse': HeartPulse,
  'dollar-sign': DollarSign,
  'home': Home,
  'graduation-cap': GraduationCap,
  'truck': Truck
};

const Industries = () => {
  return (
    <section id="industries" className="py-10 bg-[#0B0F14] relative">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-6 space-y-4">
          <h2 className="text-4xl lg:text-5xl font-bold text-white font-['Qurova',sans-serif]">
            Industries <span className="text-[#3DF2E0]">We Serve</span>
          </h2>
          {/*<p className="text-xl text-[#9CA3AF] font-['League_Spartan'] max-w-2xl mx-auto">
            AI automation solutions tailored for every industry
          </p>*/}
        </div>

        {/* Industries Grid */}
        <div className="overflow-visible relative py-6">
          <div className="flex gap-4 animate-scroll hover:[animation-play-state:paused]">

            {[...industries, ...industries].map((industry, index) => {
              const IconComponent = iconMap[industry.icon];

              return (
                <div
                  key={index}
                  onMouseMove={(e) => {
                    const rect = e.currentTarget.getBoundingClientRect();
                    const x = e.clientX - rect.left;
                    const y = e.clientY - rect.top;
                    e.currentTarget.style.setProperty("--x", `${x}px`);
                    e.currentTarget.style.setProperty("--y", `${y}px`);
                  }}
                  className="group relative flex-shrink-0 w-34 md:w-44 h-30 md:h-40 bg-[#0B0F14] border border-[#1F2933] rounded-md p-4 flex flex-col items-center justify-center text-center space-y-3 cursor-pointer transition-all duration-300 hover:border-[#3DF2E0] hover:-translate-y-1 hover:shadow-[0_0_25px_rgba(61,242,224,0.3)]"
                >

                  {/* cursor glow */}
                  <div
                    className="pointer-events-none absolute -inset-0 rounded-[inherit] opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                    style={{
                      background: `radial-gradient(
                400px circle at var(--x) var(--y),
                rgba(61,242,224,0.35),
                rgba(61,242,224,0.15) 40%,
                transparent 80%
              )`
                    }}
                  />

                  {/* content */}
                  <div className="relative z-10 flex flex-col items-center space-y-3">

                    <div className="w-12 h-12 rounded-md border border-[#1F2933] flex items-center justify-center group-hover:border-[#3DF2E0] transition">
                      <IconComponent className="w-6 h-6 text-[#3DF2E0]" />
                    </div>

                    <h3 className="text-sm font-medium text-white group-hover:text-[#3DF2E0] transition font-['Qurova',sans-serif]">
                      {industry.name}
                    </h3>

                  </div>

                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Industries;
